const siteContent = {
  whatsapp: {
    number: "5511999999999",
    budgetMessage: "Olá! Quero solicitar um orçamento."
  },
  yampi: {
    baseUrl: "https://seguro.sualoja.com.br/r",
    productToken: "SEU_TOKEN_AQUI"
  },

  nav: [
    { label: 'Início', href: '#home' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Produto', href: '#produtos' },
    { label: 'Máquinas', href: '#fabrica' },
    { label: 'Diferenciais', href: '#contato' }
  ],

  hero: {
    eyebrow: 'Impressão DTF de Alta Performance',
    title1: 'O METRO DE',
    title2: 'IMPRESSÃO',
    titleAccent: 'DTF',
    title3: 'QUE VOCÊ PRECISA',
    subtitle:
      'Estampas únicas, feitas para você. Direto da fábrica, sem atravessadores. Alta definição, cores vivas e entrega para todo o Brasil.',
    stats: [
      { target: 10000, label: 'Metros Vendidos' },
      { target: 5000, label: 'Clientes Atendidos' },
      { target: 5, label: 'Anos de Experiência' }
    ]
  },

  about: {
    label: 'Por que a Estampas Brasil?',
    title: 'Preço de Fábrica,',
    titleAccent: 'Qualidade',
    titleEnd: 'de Gigante',
    paragraphs: [
      'Na Estampas Brasil, você compra o metro de impressão DTF direto da fábrica sem atravessadores, sem enrolação.',
      'Produzimos com tecnologia de ponta para garantir cores precisas e alta durabilidade em cada centímetro.',
      'Aqui você tem empresa sólida, estrutura própria e um compromisso claro: entregar exatamente o que foi combinado, no prazo certo.'
    ],
    cards: [
      { icon: '⚡', title: 'Alta Performance', text: 'Produção rápida e estável.' },
      { icon: '🎯', title: 'Precisão', text: 'Cores vivas e acabamento forte.' },
      { icon: '🏭', title: 'Direto da Fábrica', text: 'Mais controle e preço justo.' },
      { icon: '🚚', title: 'Entrega Nacional', text: 'Atendemos todo o Brasil.' }
    ]
  },

  product: {
    label: "Venda por metro",
    title: "Rolo de",
    titleAccent: "DTF",
    description: "Escolha a quantidade de metros e compre direto pelo checkout.",
    features: [
      "Alta qualidade de impressão",
      "Material premium",
      "Compra prática e rápida",
      "Desconto progressivo por metragem"
    ]
  },

  factory: {
    label: 'Estrutura',
    title: 'Máquinas em',
    titleAccent: 'Operação',
    subtitle:
      'Estrutura moderna para produzir com constância, velocidade e controle de qualidade.'
  },

  differentials: {
    label: 'Diferenciais',
    title: 'Por que comprar com a',
    titleAccent: 'Estampas Brasil',
    items: [
      {
        number: '01',
        title: 'Qualidade consistente',
        text: 'Padrão de impressão forte do começo ao fim.'
      },
      {
        number: '02',
        title: 'Preço direto de fábrica',
        text: 'Sem atravessadores pesando no seu custo.'
      },
      {
        number: '03',
        title: 'Atendimento rápido',
        text: 'Suporte para orçamento e produção.'
      }
    ]
  },

  cta: {
    title: 'Peça agora seu',
    titleAccent: 'orçamento',
    subtitle:
      'Fale com nossa equipe no WhatsApp e receba atendimento rápido para seu pedido.'
  },

  footer: {
    description:
      'Impressão DTF com estrutura profissional, alta definição e atendimento para todo o Brasil.'
  }
};

export default siteContent;